import { Routes, Route } from "react-router-dom";

import { ProtectedLayout } from "./components/layout/Protected";
import { PublicLayout } from "./components/layout/Public";

import { DashboardPage } from "./pages/Dashboard";
import { LoginPage } from "./pages/Login";
import { ForgotPasswordPage } from "./pages/ForgotPassword";
import { ResetPasswordPage } from "./pages/ResetPassword";
import { OrganizationsPage } from "./pages/Organizations";
import { CustomerDashboardPage } from "./pages/CustomerDashboard";
import { CustomerDashboardMonthlyDetailsPage } from "./pages/CustomerDashboardMonthlyDetails";
import { ContractsPage } from "./pages/Contracts";
import { ServicesPage } from "./pages/Services";
import { ProductsPage } from "./pages/Products";
import { ProductGroupsPage } from "./pages/ProductGroups";
import { SystemPluginsPage } from "./pages/SystemPlugins";
import { ReportsPage } from "./pages/Reports";
import { LogsPage } from "./pages/Logs";
import { UsersPage } from "./pages/Users";
import { GroupsPage } from "./pages/Groups";
import { NotFoundPage } from "./pages/NotFound";
import { EmailTemplatesPage } from "./pages/EmailTemplates";

import { OrganizationProductAnalysisReport } from "./pages/reports/OrganizationProductAnalysis";
import { CreateServicePage } from "./pages/CreateServicePage";
import { AnnouncementsPage } from "./pages/Announcements";
import { AnnouncementDetailPage } from "./pages/AnnouncementDetail";
import { DocNoSettingsPage } from "./pages/DocNoSettings";
import { MillionProductMappingPage } from "./pages/MillionProductMapping";
import { CountrySyncSettingsPage } from "./pages/CountrySyncSettings";
import { UtilityLicensePage } from "./pages/UtilityLicense";
import { UtilityLicenseV2Page } from "./pages/UtilityLicenseV2";
import { RepurchaseCustomersAnalysisPage } from "./pages/RepurchaseCustomersAnalysis";
import { RepurchaseCustomersListPage } from "./pages/RepurchaseCustomersList";
import { NewCustomersAnalysisPage } from "./pages/NewCustomersAnalysis";
import { NewCustomersListPage } from "./pages/NewCustomersList";
import { DormantCustomersAnalysisPage } from "./pages/DormantCustomersAnalysis";
import { DormantCustomersListPage } from "./pages/DormantCustomersList";
import { ContinuousActiveCustomersAnalysisPage } from "./pages/ContinuousActiveCustomersAnalysis";
import { ContinuousActiveCustomersListPage } from "./pages/ContinuousActiveCustomersList";
import { NetSalesCustomersPage } from "./pages/NetSalesCustomers";

export default function AppRoutes() {
    return (
        <Routes>
            <Route element={<PublicLayout />}>
                <Route path="/" element={<LoginPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
                <Route path="*" element={<NotFoundPage />} />
            </Route>

            <Route element={<ProtectedLayout />}>
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/organizations" element={<OrganizationsPage />} />
                <Route path="/organizations/:orgId/dashboard" element={<CustomerDashboardPage />} />
                <Route path="/customer-dashboard/monthly-product-details" element={<CustomerDashboardMonthlyDetailsPage />} />
                <Route path="/contracts" element={<ContractsPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/product-groups" element={<ProductGroupsPage />} />
                <Route path="/system-plugins" element={<SystemPluginsPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/reports/organization-product-analysis-report" element={<OrganizationProductAnalysisReport />} />
                <Route path="/logs" element={<LogsPage />} />
                <Route path="/users" element={<UsersPage />} />
                <Route path="/groups" element={<GroupsPage />} />
                <Route path="/servicesssss" element={<CreateServicePage />} />
                <Route path="/announcements" element={<AnnouncementsPage />} />
                <Route path="/announcement-detail" element={<AnnouncementDetailPage />} />
                <Route path="/doc-no-settings" element={<DocNoSettingsPage />} />
                <Route path="/email-templates" element={<EmailTemplatesPage />} />
                <Route path="/million-product-mapping" element={<MillionProductMappingPage />} />
                <Route path="/country-sync-settings" element={<CountrySyncSettingsPage />} />
                <Route path="/utility-license" element={<UtilityLicensePage />} />
                <Route path="/utility-license-v2" element={<UtilityLicenseV2Page />} />
                <Route path="/organizations/repurchase-customers-analysis" element={<RepurchaseCustomersAnalysisPage />} />
                <Route path="/organizations/repurchase-customers-analysis/list" element={<RepurchaseCustomersListPage />} />
                <Route path="/organizations/new-customers-analysis" element={<NewCustomersAnalysisPage />} />
                <Route path="/organizations/new-customers-analysis/list" element={<NewCustomersListPage />} />
                <Route path="/organizations/dormant-customers-analysis" element={<DormantCustomersAnalysisPage />} />
                <Route path="/organizations/dormant-customers-analysis/list" element={<DormantCustomersListPage />} />
                <Route path="/organizations/continuous-active-customers-analysis" element={<ContinuousActiveCustomersAnalysisPage />} />
                <Route path="/organizations/continuous-active-customers-analysis/list" element={<ContinuousActiveCustomersListPage />} />
                <Route path="/organizations/net-sales-customers" element={<NetSalesCustomersPage />} />
            </Route>
        </Routes>
    );
}
